import React from "react";

import { CandidatesSection } from "@modules/ServiceRequest/Components/CandidatesSection";

import { Container } from "@UI/Components/Container/Container";
import { VStack, Stack } from "@UI/Components/Stack/Stack";
import {
  Wizard,
  WizardContent,
  WizardNav,
} from "@Shared/Components/Layouts/Wizard/Wizard";
import { BackLink } from "@Shared/Components/BackLink/BackLink";
import { ServiceRequestDetailCard } from "@modules/ServiceRequest/Components/ServiceRequestDetailCard/ServiceRequestDetailCard";
import ServiceRequestNextSteps from "@modules/ServiceRequest/Components/ServiceRequestNextSteps";
import { withFlow } from "@Libs/Flow/hocs/withFlow";
import { ServiceRequestFlow } from "@modules/ServiceRequest/Flows/ServiceRequestFlow";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { useServiceRequestFlow } from "@modules/ServiceRequest/hooks/useServiceRequestFlow";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "@modules/ServiceRequest/Components/messages";
import useMediaQuery from "@UI/hooks/useMediaQuery";
import { FAQSection } from "@modules/CustomerSupport/Components/FAQSection/FAQSection";
import { Box } from "@UI/Components/Box/Box";

export const ServiceRequest = withFlow(ServiceRequestFlow, () => {
  const { backRoute } = useServiceRequestFlow();
  const { isMobile } = useMediaQuery();

  const navigate = useNavigate();

  return (
    <>
      <Wizard
        paddingTop={{ base: 5, md: 8 }}
        maxW={["container.md", "container.sm", "container.md", "container.xl"]}
      >
        <WizardNav>
          <BackLink
            text={<FormattedMessage {...messages["goToMyDemands"]} />}
            onClick={() => {
              navigate(backRoute.to, {
                reload: true,
              });
            }}
          />
        </WizardNav>
        <WizardContent>
          <Stack direction={{ base: "column", lg: "row" }} spacing="32px">
            <VStack w="full" alignItems="start" spacing="0">
              {/* START: Task detail card */}
              <ServiceRequestDetailCard />
              {/* END: Task detail card */}
              <CandidatesSection />
            </VStack>
            <ServiceRequestNextSteps />
          </Stack>
          {isMobile && (
            <Box marginTop="10">
              <FAQSection />
            </Box>
          )}
        </WizardContent>
      </Wizard>
      {!isMobile && (
        <Container
          marginY={[10, 10, 20]}
          maxW={["container.lg", "container.md", "container.lg"]}
        >
          <FAQSection />
        </Container>
      )}
    </>
  );
});
